export default __webpack_public_path__ + "static/media/04_photo.b2e9e757.jpg";